module.exports = __webpack_public_path__ + "static/media/PM19.44169685.png";